/* eslint-disable */

import { Injectable } from '@angular/core';
import { LoggerService } from '../logger.service';
import { MatcherService } from './matcher.service';
import { SettersService } from './setters.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class SetterService {
  constructor(
    private logger: LoggerService,
    private matcher: MatcherService,
    private setters: SettersService
  ) {}

  set(setter, surveyData) {
    if (!setter) {
      return Promise.resolve();
    } // most pages won't have a setter

    const promises = [];
    const pickSetter = (element) => {
      const setValues = element.set;
      let i = 0;
      const getOrReject = async (choice) => {
        const test = choice.if || choice.elif;
        const conditionals = (choice.if ? 1 : 0) + (choice.elif ? 1 : 0) + (choice.hasOwnProperty('else') ? 1 : 0);

        if (conditionals !== 1) {
          throw 'Exactly 1 of [if, elif, else] expected in ' + JSON.stringify(choice);
        }

        if (choice.hasOwnProperty('else')) {
          return Promise.resolve(choice.set);
        } else {
          const passed = await this.matcher.conditionsMatch(test, surveyData);
          return passed ? Promise.resolve(choice.set) : Promise.reject('testFailure');
        }
      };
      const chooseSetter = () => {
        if (Array.isArray(element)) {
          return getOrReject(element[i])['catch']((testfailReason) => {
            if (++i < element.length) {
              return chooseSetter();
            } else {
              //do we need anything here?
              //is this needed ?
            }
          });
        } else {
          return getOrReject(element)['catch']((testFailReason) => {});
        }
      };

      return chooseSetter();
    };

    // pickSetter(setter)
    //     .then(valuesToSet =>{
    //         if(!valuesToSet) {
    //             return Promise.resolve(); //nothing to set
    //         }
    //         if (Array.isArray(valuesToSet)) {
    //             valuesToSet.forEach(s => {
    //                 promises.push(this.setValue(s, surveyData));
    //             });
    //         } else {
    //             promises.push(this.setValue(valuesToSet, surveyData));
    //         }

    //         return Promise.all(promises).then(() => { return Promise.resolve(); });
    // });

    const setters = [];
    let count = 0;
    const proms = [];

    if (Array.isArray(setter)) {
      setter.forEach((s, i) => {
        if (s.hasOwnProperty('if')) {
          setters.push([s]);
          count++;
        } else {
          setters[count - 1].push(s);
        }
      });
    }

    setters.forEach((s) => {
      proms.push(
        pickSetter(s).then((valuesToSet) => {
          if (!valuesToSet) {
            return Promise.resolve(); //nothing to set
          }
          if (Array.isArray(valuesToSet)) {
            valuesToSet.forEach((s) => {
              promises.push(this.setValue(s, surveyData));
            });
          } else {
            promises.push(this.setValue(valuesToSet, surveyData));
          }

          return Promise.all(promises).then(() => Promise.resolve());
        })
      );
    });

    // added the 'resolve' to satisfy typescript
    return Promise.all(proms).then(() => Promise.resolve());
  }

  private setValue(colVal, surveyData) {
    const col = colVal.column;
    if (typeof colVal.value === 'object') {
      if (colVal.value.hasOwnProperty('fn')) {
        return this.runFn(colVal.value.fn, surveyData).then(
          (value) => {
            surveyData[col] = value;
          },
          (reason) => {
            this.logger.log('Setter fn failed for ' + col + ', ' + reason, MSRemoteLoggerCategory.SURVEY_SETTER_SERVICE);
          }
        );
      } else if (colVal.value.hasOwnProperty('id')) {
        surveyData[col] = colVal.value.id;
      }
    } else {
      surveyData[col] = colVal.value;
    }
  }

  private runFn(fn, surveyData) {
    const fnName = Array.isArray(fn) ? fn[0] : fn;

    if (!this.setters[fnName]) {
      const notAvailableMsg = 'Fn N/A: ' + fnName;
      this.logger.error(notAvailableMsg, MSRemoteLoggerCategory.SURVEY_SETTER_SERVICE, fn);
      throw notAvailableMsg;
    }

    if (Array.isArray(fn)) {
      // e.g.: "{fn: [nextRandomizedNoReplacement, rq, 0, 2]}}" calls setters.nextRandomizedNoReplacement(surveyData, 'rq', 0, 2);
      return this.setters[fnName].apply(this.setters, [surveyData].concat(fn.slice(1)));
    } else {
      // e.g. "{fn: 'getStartSeconds'}" (no params to pass)
      return this.setters[fnName].apply(this.setters, [surveyData]);
    }
  }
}
